import React from 'react'
import { useNavigate } from 'react-router-dom'
import WidgetCard from './WidgetCard'
import { GhostButton, Row } from '../../../layout/styledComponents'

export default function UnreadMessageCard({ data }) {
  const navigate = useNavigate()
  if (!data || !data.messages) return null
  return (
    <WidgetCard title="Unread messages" badge={`${data.messages} new`}>
      <p style={{ margin: '0 0 16px', color: '#1F2937', fontSize: 15 }}>
        You have <strong>{data.messages}</strong> unread {data.messages === 1 ? 'message' : 'messages'} from your care team.
      </p>
      <Row $gap="10px" $wrap>
        <GhostButton onClick={() => navigate('/patient-home/messages')}>Open inbox</GhostButton>
      </Row>
    </WidgetCard>
  )
}
